import React from 'react'
import { ButtonStartPropsType } from './types'

// Styles
import './styles.scss'

export default ({ title, onClick, style, disabled }: ButtonStartPropsType) => {
  return (
    <button
      disabled={disabled}
      style={style}
      className={'button-start'}
      onClick={onClick}
    >
      {title}
    </button>
  )
}
